import "./index.scss";

export default function (props) {
  const {onClickDeleteConfirm} = props;
  return (
    <div>
      <div className="ace-editor_delete-popup">
        <p className="ace-editor_delete-popup_row delete-popup_message">
          Do you want to delete all?
        </p>
        <div className="ace-editor_delete-popup_row">
          <p
            className="ace-editor_delete-popup_col delete-popup_answers"
            onClick={() => onClickDeleteConfirm(true)}
          >
            Yes
          </p>
          <p
            className="ace-editor_delete-popup_col delete-popup_answers"
            onClick={() => onClickDeleteConfirm(false)}
          >
            No
          </p>
        </div>
      </div>
    </div>
  );
}
